import * as React from 'react'
import Trash from '../../../../../../../assets/icons_new/DeleteColor.svg'
import Print from '../../../../../../../assets/icons_new/PrintColor.svg'
import Edit from '../../../../../../../assets/icons_new/EditPencilColor.svg'
import CreateTemplateColor from '../../../../../../../assets/icons_new/CreateTemplateColor.svg'
import AddAnnex from '../../../../../../../assets/icons_new/AddAnnexColor.svg'
import TableActionBar from '@/modules/drivers/shared/tableItems/TableActionBar'
import { TableActionButtonInterface } from '@/modules/drivers/types'
import useContractService from '@/modules/drivers/services/ContractService'
import { useTable } from '@/modules/drivers/context/TableContext'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const DriverContractActions = ({
  companyId,
  driverId,
  setIsOpenEdit,
  setIsOpenAnnex,
  setIsOpenCreateTemplate,
}) => {
  const { selectedGroup, resetAll } = useTable()
  const { triggerRefresh } = useDrivers()
  const { t } = useLocalize()
  const { deleteContracts } = useContractService()
  const actions: TableActionButtonInterface[] = [
    {
      icon: Edit,
      action: () => setIsOpenEdit(true),
      tooltip: t('common.edit'),
    },
    // @TODO: enable after implementing template feature
    // {
    //   icon: AddContractByTemplate,
    //   action: () => console.log(),
    //   tooltip: 'Dodaj umowę na podstawie szablonu',
    //   disabled: true,
    // },
    {
      icon: AddAnnex,
      action: () => setIsOpenAnnex(true),
      tooltip: t('driverModule.add-annex'),
      // disabled: selectedGroup?.additionalType !== 'CONTRACT'
    },
    {
      icon: CreateTemplateColor,
      action: () => setIsOpenCreateTemplate(true),
      tooltip: 'Stwórz szablon na podstawie umowy',
    },
    // @TODO: enable print action
    {
      icon: Print,
      action: () => console.log(),
      tooltip: t('common.print'),
      disabled: true,
    },
    {
      icon: Trash,
      action: () =>
        deleteContracts({
          companyId: companyId,
          driverId: driverId,
          contractsIds: selectedGroup?.ids,
        }).finally(() => {
          resetAll()
          triggerRefresh()
        }),
      tooltip: t('common.delete'),
    },
  ]
  return (
    <>
      <TableActionBar actions={actions} />
    </>
  )
}

export default DriverContractActions
